import { useEffect, useState } from "react"

import { useTranslation } from "react-i18next"

import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { useAvailableGPTModels } from "@/hooks/use-config-query"
import { KNOWN_SESSION_TYPES } from "@/types"

export function DemoModelSelector() {
  const { t } = useTranslation()
  const { models, isLoading } = useAvailableGPTModels(KNOWN_SESSION_TYPES.Explorer)
  const [selectedModelId, setSelectedModelId] = useState<string | null>(null)

  useEffect(() => {
    if (models.length > 0 && !selectedModelId) {
      const defaultModel = models.find((model) => model.default) || models[0]
      setSelectedModelId(defaultModel.id)
    }
  }, [models, selectedModelId])

  const selectedModel = models.find((model) => model.id === selectedModelId) || models[0]

  if (isLoading || models.length === 0) {
    return (
      <section className="flex w-full flex-col gap-1 sm:max-w-xs">
        <Label>{t("customgptmodelsettings.choose_model")}</Label>
        <Select disabled>
          <SelectTrigger>
            <SelectValue placeholder={t("common.loading")} />
          </SelectTrigger>
        </Select>
      </section>
    )
  }

  return (
    <section className="flex w-full flex-col gap-1 sm:max-w-xs">
      <Tooltip>
        <TooltipTrigger className="w-full text-left">
          <Label>{t("customgptmodelsettings.choose_model")}</Label>
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="left">
          <p>{t("settingsmenu.language_model")}</p>
        </TooltipContent>
      </Tooltip>
      <Select value={selectedModelId || undefined} onValueChange={(id) => setSelectedModelId(id)}>
        <SelectTrigger>
          <SelectValue placeholder={t("customgptmodelsettings.choose_model")}>
            {selectedModel.display_name}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {models.map((model) => (
            <Tooltip key={model.id}>
              <TooltipTrigger asChild className="w-full">
                <SelectItem value={model.id}>{model.display_name}</SelectItem>
              </TooltipTrigger>
              <TooltipContent side="left">
                <p>{model.description}</p>
              </TooltipContent>
            </Tooltip>
          ))}
        </SelectContent>
      </Select>
    </section>
  )
}
